import actions from '../action/common'
import CONSTANT from '../constant/common'
export default {
    actions,
    state: {
    },
    mutations: {
        [CONSTANT.COMMON_GETSMSCODE_SUCCESS] (state, data) {
            
        },
        [CONSTANT.COMMON_GETSMSCODE_ERROR] (state, e) {
           
        },
        [CONSTANT.COMMON_GETUSERINFO_SUCCESS] (state, data) {
            
        },
        [CONSTANT.COMMON_GETUSERINFO_ERROR] (state, e) {
            
        },
        [CONSTANT.COMMON_GETCAPTCHA_SUCCESS] (state, data) {
            
        },
        [CONSTANT.COMMON_GETCAPTCHA_ERROR] (state, e) {
            
        },
        [CONSTANT.COMMON_ISFOLLOWEDWECHAT_SUCCESS] (state, data) {
            
        },
        [CONSTANT.COMMON_ISFOLLOWEDWECHAT_ERROR] (state, e) {
            
        },
        [CONSTANT.COMMON_SENDWECHATMSGTPL_SUCCESS] (state, data) {
            
        },
        [CONSTANT.COMMON_SENDWECHATMSGTPL_ERROR] (state, e) {
            
        },
        /*yeoman-template-point-1*/
    }
}